import { useCallback } from 'react';
import { useToast as useToastParallax } from '@adc/parallax-component-library';
const useToast = () => {
    const { showToast: showToastParallax } = useToastParallax();
    const showToast = useCallback((props) => {
        showToastParallax({
            ...props,
        });
    }, [showToastParallax]);
    return { showToast };
};
export default useToast;
